// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3EJWJ","col":"styles_col__1EIJ9","fulfillmentStatus":"styles_fulfillmentStatus__2f3Pd","emailCol":"styles_emailCol__1z3_9"};